import { HttpParams } from '@angular/common/http';

import { SN_HTTP_PARAMETER_CODEC } from './http-parameter-codec';

export function httpParamsTransformer(params: { [key: string]: any }): HttpParams {
  let httpParams = new HttpParams({
    fromObject: params,
    encoder: SN_HTTP_PARAMETER_CODEC,
  });

  httpParams.keys().forEach((key) => {
    const values = httpParams
      .getAll(key)
      .filter((value) => ![undefined, null, 'undefined', 'null'].includes(value));

    if (!values.length) {
      httpParams = httpParams.delete(key);
    }
  });

  return httpParams;
}
